var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { Component } from 'react';



import comonProperties from "../../../shared/commonProperties";
import { Icon } from "../../UI";

import { Translate } from "../../I18N";
import { actions, ShowMetadata, wrapEntityMetadata } from "./..";
import { store } from "../../store";

import { SearchEntities } from "./SearchEntities";
















class CopyFromEntity extends Component {


  constructor(props) {
    super(props);_defineProperty(this, "templates", void 0);

    this.state = { propsToCopy: [], selectedEntity: {}, lastSearch: undefined };
    this.templates = this.props.templates.toJS();
    this.onSelect = this.onSelect.bind(this);
    this.cancel = this.cancel.bind(this);
    this.copy = this.copy.bind(this);
    this.backToSearch = this.backToSearch.bind(this);
    this.onFinishedSearch = this.onFinishedSearch.bind(this);
  }

  onSelect(selectedEntity) {
    const copyFromTemplateId = selectedEntity.template;
    const originalTemplate = this.props.originalEntity.template;

    const propsToCopy = comonProperties.
    comonProperties(
      this.templates,
      [originalTemplate, copyFromTemplateId],
      ['generatedid', 'media', 'image']
    ).
    map((p) => p.name);

    this.setState({ selectedEntity, propsToCopy });
    this.props.onSelect(propsToCopy, selectedEntity);
  }

  onFinishedSearch(searchTerm) {
    this.setState({ lastSearch: searchTerm });
  }

  copy() {
    if (!this.state.selectedEntity.metadata) {
      return;
    }

    const entityTemplate = this.templates.find(
      (template) => template._id === this.props.originalEntity.template
    );

    const originalEntity = wrapEntityMetadata(
      this.props.originalEntity,
      entityTemplate
    );

    const updatedEntity = this.state.propsToCopy.reduce(
      (entity, propName) => {
        if (!entity.metadata) {
          return _objectSpread(_objectSpread({}, entity), {}, { metadata: {} });
        }

        const updatedMetadata = this.state.selectedEntity.metadata[propName];

        return _objectSpread(_objectSpread({},
        entity), {}, {
          metadata: _objectSpread(_objectSpread({}, entity.metadata), {}, { [propName]: updatedMetadata }) });

      }, _objectSpread({},
      originalEntity)
    );

    actions.
    loadFetchedInReduxForm(this.props.formModel, updatedEntity, this.templates).
    forEach((action) => store === null || store === void 0 ? void 0 : store.dispatch(action));

    this.props.onSelect([]);
    this.props.onCancel();
  }

  backToSearch() {
    this.setState({ propsToCopy: [], selectedEntity: {} });
    this.props.onSelect([]);
  }

  cancel() {
    this.props.onSelect([]);
    this.props.onCancel();
    this.setState({ propsToCopy: [], selectedEntity: {} });
  }

  renderPanel() {
    return this.state.selectedEntity._id ? /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("div", { className: "view" }, void 0, /*#__PURE__*/
    _jsx(ShowMetadata, {
      entity: this.state.selectedEntity,
      showTitle: true,
      showType: true,
      highlight: this.state.propsToCopy,
      excludePreview: true }
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "copy-from-buttons btn-cluster" }, void 0, /*#__PURE__*/
    _jsx("button", {
      className: "back-copy-from btn btn-light",
      type: "button",
      onClick: this.backToSearch }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: "arrow-left" }), /*#__PURE__*/
    _jsx("span", { className: "hidden btn-label" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Back to search")
    )
    ), /*#__PURE__*/
    _jsx("button", { className: "cancel-copy-from btn btn-light", type: "button", onClick: this.cancel }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "times" }), /*#__PURE__*/
    _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")
    )
    ), /*#__PURE__*/
    _jsx("button", { className: "copy-copy-from btn btn-success", type: "button", onClick: this.copy }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "copy-from", transform: "left-0.075 up-0.1" }), /*#__PURE__*/
    _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Copy Highlighted")
    )
    )
    )
    ) : /*#__PURE__*/

    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(SearchEntities, {
      onSelect: this.onSelect,
      onFinishSearch: this.onFinishedSearch,
      initialSearchTerm: this.state.lastSearch }
    ), /*#__PURE__*/
    _jsx("div", { className: "copy-from-buttons btn-cluster" }, void 0, /*#__PURE__*/
    _jsx("button", { className: "cancel-copy-from btn btn-light", type: "button", onClick: this.cancel }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "times" }), /*#__PURE__*/
    _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")
    )
    )
    )
    );

  }

  render() {
    return /*#__PURE__*/_jsx("div", { className: "copy-from" }, void 0, this.props.isVisible && this.renderPanel());
  }
}


export { CopyFromEntity };